import { BackButton } from '@airship-platform/airship-patterns';
import {
  useManageProducts,
  useProductsQueryFilterParams,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router';
import ROUTE_PATHS from '../../routes/paths';

const ProductsQueryPage: React.FC = () => {
  const { appointmentId, appointmentProposalId, appointmentProposalOptionId } =
    useParams<{
      appointmentId: string;
      appointmentProposalId: string;
      appointmentProposalOptionId: string;
    }>();
  const { displaySettings, setDisplaySettings, setProductDefaults } =
    useManageProducts();
  const { isInitialised, groupingName } = useProductsQueryFilterParams();
  const [searchParams] = useSearchParams();
  const itemGroupRootId = searchParams.get('itemGroupRootId');

  useEffect(() => {
    if (groupingName) {
      setProductDefaults({
        groupingName,
      });
    }
  }, [groupingName, setProductDefaults]);

  useEffect(() => {
    if (appointmentProposalOptionId) {
      setDisplaySettings({
        selectedOptionIds: [appointmentProposalOptionId],
      });
    }
  }, [appointmentProposalOptionId, setDisplaySettings]);

  const showBackToItem =
    !!itemGroupRootId &&
    !!appointmentId &&
    !!appointmentProposalId &&
    !!appointmentProposalOptionId;

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      {showBackToItem && (
        <Box>
          <BackButton
            color="softGold"
            displayIcon
            backPath={ROUTE_PATHS.PROPOSAL_OPTIONS_PATH({
              appointmentId,
              appointmentProposalId,
              appointmentProposalOptionId,
              extraPath: `product/${itemGroupRootId}`,
            })}
            defaultPath="../"
          >
            Back to item
          </BackButton>
        </Box>
      )}
      <Typography variant="h2">{displaySettings.productPageTitle}</Typography>
      {isInitialised && <Outlet />}
    </FlexBox>
  );
};

export default ProductsQueryPage;
